import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-chevron-up-icon lucide-chevron-up",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m18 15-6-6-6 6" })
});
export default SvgChevronUp;
